import React from 'react';
import { Box } from '@mui/material';

interface RichTextDisplayProps {
  content: string;
  variant?: 'body1' | 'body2';
}

const RichTextDisplay: React.FC<RichTextDisplayProps> = ({ content, variant = 'body1' }) => {
  if (!content || content.trim() === '') {
    return null;
  }

  const cleanContent = content.trim();
  if (cleanContent === '<p><br></p>' || cleanContent === '<br>' || cleanContent === '<p></p>') {
    return null;
  }

  return (
    <Box
      sx={{
        '& p': {
          margin: 0,
          marginBottom: 1,
          '&:last-child': {
            marginBottom: 0,
          },
        },
        '& h1, & h2, & h3': {
          margin: 0,
          marginBottom: 1,
          fontWeight: 600,
        },
        '& h1': {
          fontSize: '1.5rem',
        },
        '& h2': {
          fontSize: '1.25rem',
        },
        '& h3': {
          fontSize: '1.1rem',
        },
        '& ul, & ol': {
          margin: 0,
          marginBottom: 1,
          paddingLeft: 2,
        },
        '& li': {
          marginBottom: 0.5,
        },

        '& strong': {
          fontWeight: 600,
        },
        fontSize: variant === 'body1' ? '1rem' : '0.875rem',
        lineHeight: 1.6,
        color: 'text.primary',
      }}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};

export default RichTextDisplay;
